export default "__VITE_ASSET__DBmuggu___"